import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonService } from './common.service';
import { Locale } from '../_models';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { UserInfoService } from './userInfo.service';

export const countrykey = { headers: { 'X-CSCAPI-KEY': 'NjUxYURMOEtQcXJQeTFaRTVwUzBUZllucVhFQ0NVemtGOTZ0OE5GZw==' } };

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private commonService: CommonService, private http: HttpClient, readonly userInfoService: UserInfoService) { }

    getAll() {
        return this.commonService.getCall(`${environment.API_BASE_PATH}/users`);
    }

    getById(id: number) {
        return this.commonService.getCall(`${environment.API_BASE_PATH}/users/${id}`);
    }

    getAllUsers(index, rows, column, direction, search, userType): Observable<any> {
        let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'user_type': String(userType),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.http.get(environment.API_BASE_PATH + '/users/findall', headers);
    }

    getUserDetails(id: any) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.http.get(environment.API_BASE_PATH + `/users/findbyid/${id}`, headers);
    }

    changeRejectedStatus(id: any, val) {
        return this.commonService.patchCall(environment.API_BASE_PATH + `/rfids/${id}/reactivate`, val);
    }

    deleteUserById(id) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.deleteCall(environment.API_BASE_PATH + `/users/delete/${id}` , headers);
    }

    // changePassword(headers) {
    //     return this.commonService.getCall(environment.API_BASE_PATH + '/change/password', headers);
    // }

    changeOldPassword(oldpass, email, newpass, role) {
        let headers = { headers: { 'password': String(oldpass), 'key': String(email), 'new_password': String(newpass), 'role': String(role), 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.patchCall(environment.API_BASE_PATH + '/users/change/password', {}, headers);
    }

    getAllTickets(index, rows, column, direction, search) {
        let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/ticket/list', headers);
    }

    getTicketById(id) {
        return this.commonService.getCall(environment.API_BASE_PATH + `/ticket/${id}`);
    }

    getTicketsByVendorEmail(email, index, rows, column, direction, search) {
        let headers = { headers: { vendorEmail: String(email), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/ticket', headers);
    }

    UpdateTicket(data) {
        return this.commonService.putCall(environment.API_BASE_PATH + '/ticket/update', data);
    }

    postServiceRequest(data: FormData) {
        return this.commonService.postCall(environment.API_BASE_PATH + '/ticket/save', data);
    }

    deleteTicket(id) {
        return this.commonService.deleteCall(environment.API_BASE_PATH + `/ticket/${id}`);
    }

    getAllUpdates(index, rows, column, direction, search) {
        let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/info/list', headers);
    }

    getVendorUpdates(date, index, rows, column, direction, search) {
        let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search), 'createDate': date } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/info/vendor/list', headers);
    }

    postUpdate(data: FormData) {
        return this.commonService.postCall(environment.API_BASE_PATH + '/info/save', data);
    }

    deleteUpdate(id) {
        return this.commonService.deleteCall(environment.API_BASE_PATH + `/info/delete/${id}`);
    }

    updateWallet(input) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.putCall(environment.API_BASE_PATH + '/vendor/wallet', input, headers);
    }

    getWalletAmount(id) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.getCall(environment.API_BASE_PATH + `/wallets/user/${id}`, headers);
    }

    getTransactions(id, index, rows, column, direction, search) {
        let headers = { headers: { 'userId': String(id), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } }
        return this.commonService.getCall(environment.API_BASE_PATH + `/users/getAllTransactions/${id}`, headers);
    }

    getAdoptionTransactionById(id, index, rows, column, direction, search) {
        let headers = { headers: { 'userId': String(id), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/campaigns/adopt-a-tree/web/userId`, headers);
    }

    getLocales(): Observable<Locale[]> {
        let headers = { headers: {  'Accept-Version': 'V2' } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/locales', headers);
    }

    getLanguagesbycountry(countrycode: string = ''): Observable<any[]> {
        let headers = { headers: {  'Accept-Version': 'V2' } }
        let URL = countrycode ? environment.API_BASE_PATH + '/locales/country/' + countrycode : environment.API_BASE_PATH + '/locales/country/unique';
        return this.commonService.getCall(URL,headers);
    }

    updatePreferredLang(userID: string, lang: string): Observable<any> {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        const url = environment.API_BASE_PATH + `/users/${userID}/pref-language/${lang}`;
        const formData = new FormData();
        return this.commonService.patchCall(url, formData, headers);
    }
    updatePreferredCountry(userID: string, country: string): Observable<any> {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        const url = environment.API_BASE_PATH + `/users/${userID}/pref-country/${country}`;
        const formData = new FormData();
        return this.commonService.patchCall(url, formData, headers);
    }
    getBrandInfoByTenantId(tenantID) {
        let headers = { headers: { 'X-tenant-ID': String(tenantID) } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/tenant', headers)
    }
    createUser(data) {
        let headers = { headers: { 'Accept-Version': 'V2' } }
        let fullResponse = true
        return this.commonService.postCall(environment.API_BASE_PATH + '/users/signup', data, headers, fullResponse)
    }

    editUser(data) {
        let fullResponse = true
        let headers = { headers: {'Accept-Version': 'V2' } }
        return this.commonService.putCall(environment.API_BASE_PATH + '/users', data, headers, fullResponse)
    }

    otpValidation(id, otp, key) {
        let headers = { headers: { 'user_id': String(id), 'otp': String(otp), 'key': String(key),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        let fullResponse = true
        return this.commonService.getCall(environment.API_BASE_PATH + '/users/otp/validate', headers, fullResponse)
    }
    resendOtp(id, key, role, platform) {
        let fullResponse = true
        let headers = { headers: { 'user_id': String(id), 'key': String(key), 'role': String(role), 'platform': String(platform) ,'Accept-Version': 'V2','X-Tenant-ID': this.userInfoService.userDetails.tenantID} }
        return this.commonService.getCall(environment.API_BASE_PATH + '/users/otp', headers, fullResponse)
    }
    getInvoice(transactionId): Observable<any> {
        try {
            return this.http.get(environment.API_BASE_PATH + `/reports/invoice/${transactionId}`, { responseType: 'blob' }).pipe(map((response: any) => {
                return response;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    saveOnBoard(data, isEdit, id) {
        let headers = { headers: { 'X-Tenant-ID': 'TELIOEV','Accept-Version': 'V2' } }
        let versionHeader = { headers: { 'Accept-Version': 'V2' }}
        return !isEdit ? this.commonService.postCall(environment.API_BASE_PATH + `/tenant`, data , versionHeader) : this.commonService.putCall(environment.API_BASE_PATH + `/tenant`, data, headers);
    }

    editTenant(data, id) {
        let headers = { headers: { 'X-Tenant-ID': String(id),'Accept-Version': 'V2' } }
        return this.commonService.putCall(environment.API_BASE_PATH + `/tenant`, data, headers);
    }

    getReconcileReport(vendorId, type, startDate?: any, endDate?: any): Observable<any> {
        try {
            let headers = {};
            if (startDate && endDate) {
                headers = {
                    headers: {
                        'startDate': String(startDate),
                        'endDate': String(endDate)
                    }
                };
            }
            const val={"emails":vendorId.split(',')}
            return this.http.post(environment.API_BASE_PATH + `/reports/reconcile/${type}`,val, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getSettlementReport(vendorId, type, startDate?: any, endDate?: any): Observable<any> {
        try {
            let headers = {};
            if (startDate && endDate) {
                headers = {
                    headers: {
                        'startDate': String(startDate),
                        'endDate': String(endDate)
                    }
                };
            }
            const val={"emails":vendorId.split(',')}
            return this.http.post(environment.API_BASE_PATH + `/reports/settlement/${type}`,val, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getChargerReportDownload(type): Observable<any> {
        try {
            return this.http.get(environment.API_BASE_PATH + `/reports/cpo-chargebox-status/${type}`, { responseType: 'blob', observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getChargerReportHyperlinkDownload(vendormailid, type): Observable<any> {
        try {
            let headers = { headers: { 'cpoName': String(vendormailid) } }
            return this.http.get(environment.API_BASE_PATH + `/reports/cpo-chargeboxes-status/${type}`, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }


    getReconcileList(vendorId, index, rows, column, direction, search, startDate?: any, endDate?: any) {
        const currentDate = new Date();
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        startDate = startDate ? startDate : lastMonthDate;
        endDate = endDate ? endDate : currentDate;
        const val={"emails":vendorId.split(',')}
        let headers = { headers: { 'startDate': String(startDate), 'endDate': String(endDate), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction) } }
        return this.commonService.postCall(environment.API_BASE_PATH + `/reports/reconcile`,val, headers);
    }
    getDownloadReport(res) {
        const url = window.URL.createObjectURL(res.body);
        const contentDispositionHeader = res.headers.get('Content-Disposition');
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDispositionHeader);
        const filename = matches !== null && matches[1] ? matches[1].replace(/['"]/g, '') : 'download';
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(url);
    }

    getAllWallets(index, rows, column, direction, search) {
        let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID  } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/wallets/getAll', headers);
    }

    getWalletTransationsByWalletId(Id) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.getCall(environment.API_BASE_PATH + `/wallets/${Id}`, headers)
    }

    rechargeWallet(data, userId, code) {
        let fullResponse = true
        let headers = { headers: { 'userId': String(userId), 'countryCode': String(code) } }
        return this.commonService.postCall(environment.API_BASE_PATH + '/users/momo/payment', data, headers, fullResponse)
    }

    getAllTransacations() {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/wallets/transaction',headers)
    }

    getPendingTransactions(index, rows, column, direction, search) {
        let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) , 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/wallets/paymentDetails/pending', headers)
    }

    getFailedTransactions(index, rows, column, direction, search) {
        let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) ,'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID} };
        return this.commonService.getCall(environment.API_BASE_PATH + '/wallets/paymentDetails/fail', headers)
    }

    refreshStatus(orderId, userId) {
        let headers = { headers: { 'referenceId': String(orderId), 'userId': String(userId) } }
        return this.commonService.postCall(environment.API_BASE_PATH + '/users/momo/payment/withdraw/status', {}, headers)
    }

    getEmailOtp(id, key) {
        let headers = { headers: { 'user_id': String(id), 'key': String(key) ,'Accept-Version': 'V2','X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/users/otp', headers)
    }

    getChargingTransactions() {
        return this.commonService.getCall(environment.API_BASE_PATH + '/charging/getalltnx')
    }

    getUniqueTransaction(index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V1', 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/charging/getchargeboxdetails', headers)
    }

    getTransactionBasedOnId(chargeboxId, index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V1', 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/charging/getalltnxbychargebox/${chargeboxId}`, headers)
    }

    requestRefund(data, gateway) {
        let fullResponse = true;
        let headers = { headers: { 'paymentGateway': String(gateway) } }
        return this.http.post(environment.API_BASE_PATH + '/ormgr/refund', data, headers)
    }

    getStates(country) {
        return this.http.get<any[]>('https://api.countrystatecity.in/v1/countries/' + country + '/states', countrykey)
            .pipe(
                tap(results => {
                    results.sort((a: any, b: any) => a.name.localeCompare(b.name));
                }));
    }

    getCities(country, state) {
        return this.http.get<any[]>('https://api.countrystatecity.in/v1/countries/' + country + '/states/' + state + '/cities', countrykey)
            .pipe(
                tap(results => {
                    results.sort((a: any, b: any) => a.name.localeCompare(b.name));
                }));
    }

    getTenantList(index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V2', 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/tenant', headers);
    }

    deleteTenant(Id) {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': String(Id) } }
        return this.commonService.deleteCall(environment.API_BASE_PATH + '/tenant', headers)
    }

    deleteTenantTelioEV() {
        let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': 'TELIOEV' } }
        return this.commonService.deleteCall(environment.API_BASE_PATH + '/tenant', headers)
    }

    changeStatus(status, id) {
        let headers = { headers: { 'status': String(status), 'X-Tenant-ID': String(id) ,'Accept-Version': 'V2'} }
        let fullResponse = true
        return this.commonService.putCall(environment.API_BASE_PATH + '/tenant/status', {}, headers, fullResponse)
    }

    changeStatusTelioEV(status) {
        let headers = { headers: { 'status': String(status), 'X-Tenant-ID': 'TELIOEV','Accept-Version': 'V2' } }
        return this.commonService.putCall(environment.API_BASE_PATH + '/tenant/status', {}, headers)
    }

    getChargerReport(vendormailid, index, rows, column, direction, search) {
        let headers = { headers: { 'cpoName': String(vendormailid), 'Accept-Version': 'V1', 'startDate': String(new Date()), 'endDate': String(new Date()), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction) } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/reports/cpo-chargebox-status', headers);
    }

    getChargerReportVendor(vendormailid, index, rows, column, direction, search) {
        let headers = { headers: { 'cpoName': String(vendormailid), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search), 'Accept-Version': 'V1' } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/reports/cpo-chargeboxes-status', headers);
    }

    getSettlementList(Id, index, rows, column, direction, search, startDate?: any, endDate?: any) {
        const currentDate = new Date();
        const val={"emails":Id.split(',')}
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        startDate = startDate ? startDate : lastMonthDate;
        endDate = endDate ? endDate : currentDate;
        let headers = { headers: { 'Accept-Version': 'V1', 'startDate': String(startDate), 'endDate': String(endDate), 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction) } }
        return this.commonService.postCall(environment.API_BASE_PATH + `/reports/settlement`,val, headers);
    }

    getChargerReportMain(index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V1', 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/reports/cpo-chargebox-status', headers);
    }

    getSchedularReportMain(index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V1', 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } }
        return this.commonService.getCall(environment.API_BASE_PATH + '/reports/schedulars', headers);
    }

    createReport(val: any) {
        let headers = { headers: { 'Accept-Version': 'V1' } };
        return this.commonService.postCall(environment.API_BASE_PATH + '/reports/schedulars', val, headers);
    }

    getTenantDataById(Id) {
        let headers = { headers: { 'Accept-Version': 'V2' } }
        return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/configs/${Id}`, headers)
    }
    updateReport(id, val: any) {
        let headers = { headers: { 'Accept-Version': 'V1' } };
        return this.commonService.patchCall(environment.API_BASE_PATH + `/reports/schedulars/${id}`, val, headers);
    }

    validateSmtp(data, tenantId, isEdit) {
        let headers = !isEdit ? { headers: { 'Accept-Version': 'V2' } } : { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': String(tenantId) } };
        return this.commonService.postCall(environment.API_BASE_PATH + `/tenant/smtp/validate`, data, headers)
    }

    getAllAdminUsers(tenantId, index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-Id': tenantId, 'user_type': 'ADMIN', 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) } };
        return this.commonService.getCall(environment.API_BASE_PATH + '/users', headers)
    }

    getAllAdminUser(tenantId, index, rows, column, direction, search, userType) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-Id': tenantId, 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'user_type': String(userType) } };
        return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/user/group/${userType}`, headers)
    }

    deleteImage(tenantId, type, ImageType) {
        let headers = { headers: { 'tenant_id': tenantId, 'type': type, 'image': ImageType ,'Accept-Version': 'V2','X-Tenant-ID': this.userInfoService.userDetails.tenantID} }
        return this.commonService.deleteCall(environment.API_BASE_PATH + `/tenant/identity/image`, headers)
    }

    submitCredentials(userId,headers,val){
        return this.commonService.putCall(environment.API_BASE_PATH + `/tenant/password/user/${userId}`,val, headers)  
    }
    
    deleteVendorImage(imgType, vendorId) {
        let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
        return this.commonService.deleteCall(environment.API_BASE_PATH + `/users/vendors/${vendorId}/images/${imgType}`, headers)
    }

    createGSTDetails(input) {
        let headers = { headers: { 'Accept-Version': 'V2' } }
        return this.commonService.postCall(environment.API_BASE_PATH + '/gst/add', input, headers)
    }

    editGSTDetails(input, gst_number) {
        let headers = { headers: { 'Accept-Version': 'V2', 'Gst-Number': gst_number } }
        return this.commonService.putCall(environment.API_BASE_PATH + '/gst/update', input, headers)
    }

    getStateForNepal(){
        return this.commonService.getCall(environment.API_BASE_PATH + `/locales/country/NP/states`) 
    }

    getCitiesForNepal(stateId){
        return this.commonService.getCall(environment.API_BASE_PATH + `/locales/states/${stateId}/cities`)
    }

    getStateForSriLanka(){
        return this.commonService.getCall(environment.API_BASE_PATH + `/locales/country/LK/states`) 
    }

    getCitiesForSriLanka(stateId){
        return this.commonService.getCall(environment.API_BASE_PATH + `/locales/states/${stateId}/cities`)
    }

}